import React from 'react';
import styled from 'styled-components';

const Styled = styled.div`
`;


export interface InputValidationErrorMsgProps {
    error?: string;
    sectionRequiredLabel?: string;
}

const InputValidationErrorMsg = ({
    error,
    sectionRequiredLabel
}: InputValidationErrorMsgProps): JSX.Element => {
    return (
        <Styled className="validate-msg">
           {error === 'Required' ? (sectionRequiredLabel)  : error}
        </Styled>
    );
};

export default InputValidationErrorMsg;
